import type { ComputedColumn } from '../../shared/self-service-types';

/** Row evaluator factory — `SelfServiceFormulaService.buildRowEvaluator`'s shape. */
export type RowEvaluatorFactory = (expression: string, knownColumns: string[]) => (row: Record<string, string>) => unknown;

/**
 * Add the Formula Builder's computed columns to a copy of `rows`, in order,
 * each later column seeing the earlier ones. A column whose expression fails
 * to parse is skipped. Pure: used by the Bar & Column step for its live
 * preview and by the shell when a client-rendered tile is restored.
 */
export function applyComputedColumns(
  rows: Array<Record<string, unknown>>,
  computedColumns: ComputedColumn[],
  knownColumns: string[],
  buildEvaluator: RowEvaluatorFactory,
): Array<Record<string, unknown>> {
  if (!computedColumns.length || !rows.length) return rows;
  let working = rows.map((r) => ({ ...r }));
  const known = [...knownColumns];
  for (const computed of computedColumns) {
    try {
      const evaluator = buildEvaluator(computed.expression, known);
      working = working.map((row) => {
        const value = evaluator(row as Record<string, string>);
        const out = value === null || value === undefined ? '' : value;
        return { ...row, [computed.name]: typeof out === 'number' && !Number.isFinite(out) ? '' : out };
      });
      known.push(computed.name);
    } catch {
    }
  }
  return working;
}
